import { download, generateCsv, mkConfig } from "export-to-csv"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { useDateTime } from "../../../../localization/useDateTime"
import { AcquiringReport } from "../supplierAcquiringReportsTypes"
import { toDinero } from "../../../../currency/currencyLib"
import { useMoney } from "../../../../currency/useMoney"

export const useExportBalanceToCsv = (startDate: string, endDate: string) => {
    const { l10n } = useAppLocalization()
    const moneyFactory = useMoney({})
    const dateTimeFactory = useDateTime()
    const formattedStartDate = dateTimeFactory.formatDate(dateTimeFactory.fromISO(startDate))
    const formattedEndDate = dateTimeFactory.formatDate(dateTimeFactory.fromISO(endDate))

    const csvOptions = mkConfig({
        fieldSeparator: ";",
        quoteStrings: true,
        decimalSeparator: ",",
        useBom: true,
        useKeysAsHeaders: true,
        showColumnHeaders: false,
        filename: `Facilitynet-reconciliation-balance-${formattedStartDate}_${formattedEndDate}`,
    })

    const handleExportRows = (acquiringReport?: AcquiringReport[]) => {
        if (!acquiringReport) return
        const exportRowsForBalance = acquiringReport.map((item) => {
            return {
                column1: item.name,
                column2: moneyFactory.formatAsNumber(toDinero(item.amount)),
            }
        })

        exportRowsForBalance.unshift({
            column1: l10n.getString("supplier-overview-table-account"),
            column2: l10n.getString("supplier-overview-table-amount"),
        })

        const csv = generateCsv(csvOptions)(exportRowsForBalance)
        download(csvOptions)(csv)
    }

    return { handleExportRows }
}
